// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Wash me thoroughly from my wickedness&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and cleanse me from my sin.<br> </p> </div></div>";
// Exports
module.exports = code;